// Ready-to-use full-site templates for the "Galleria modelli" starting point.
const F = "font-family:system-ui,-apple-system,Segoe UI,Roboto,sans-serif;";

function doc(body) {
  return `<!DOCTYPE html><html lang="it"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"></head><body style="margin:0;${F}">${body}</body></html>`;
}

export const SITE_TEMPLATES = [
  {
    id: "business",
    name: "Azienda",
    desc: "Sito aziendale pulito e professionale",
    accent: "#2563eb",
    html: doc(`
      <header style="background:#0f172a;color:#fff;padding:18px 32px;display:flex;justify-content:space-between;align-items:center;">
        <strong style="font-size:20px;">La Tua Azienda</strong>
        <nav style="font-size:14px;color:#cbd5e1;">Home · Servizi · Contatti</nav>
      </header>
      <section style="background:#2563eb;color:#fff;padding:90px 32px;text-align:center;">
        <h1 style="font-size:46px;margin:0 0 14px;">Soluzioni su misura per la tua impresa</h1>
        <p style="font-size:19px;color:#dbeafe;max-width:640px;margin:0 auto 28px;">Aiutiamo le aziende a crescere con consulenza e tecnologia.</p>
        <a href="#" style="background:#fff;color:#2563eb;font-weight:700;padding:14px 30px;border-radius:8px;text-decoration:none;">Richiedi preventivo</a>
      </section>
      <section style="padding:72px 32px;max-width:1000px;margin:0 auto;text-align:center;color:#0f172a;">
        <h2 style="font-size:32px;margin:0 0 40px;">I nostri servizi</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:24px;">
          <div style="padding:24px;border:1px solid #e2e8f0;border-radius:14px;"><h3>Consulenza</h3><p style="color:#475569;">Strategia e crescita.</p></div>
          <div style="padding:24px;border:1px solid #e2e8f0;border-radius:14px;"><h3>Sviluppo</h3><p style="color:#475569;">Soluzioni digitali.</p></div>
          <div style="padding:24px;border:1px solid #e2e8f0;border-radius:14px;"><h3>Supporto</h3><p style="color:#475569;">Assistenza continua.</p></div>
        </div>
      </section>
      <footer style="background:#0f172a;color:#94a3b8;padding:28px;text-align:center;font-size:14px;">© 2026 La Tua Azienda</footer>`),
  },
  {
    id: "restaurant",
    name: "Ristorante",
    desc: "Caldo e accogliente per locali e cucina",
    accent: "#b45309",
    html: doc(`
      <header style="background:#1c1917;color:#fff;padding:18px 32px;text-align:center;">
        <strong style="font-size:24px;letter-spacing:1px;">Trattoria Bella</strong>
      </header>
      <section style="background:#78350f;color:#fff;padding:100px 32px;text-align:center;">
        <h1 style="font-size:48px;margin:0 0 14px;font-family:Georgia,serif;">Sapori autentici</h1>
        <p style="font-size:19px;color:#fed7aa;margin:0 0 28px;">Cucina tradizionale con ingredienti freschi e di stagione.</p>
        <a href="#" style="background:#f59e0b;color:#1c1917;font-weight:700;padding:14px 30px;border-radius:999px;text-decoration:none;">Prenota un tavolo</a>
      </section>
      <section style="padding:72px 32px;max-width:900px;margin:0 auto;text-align:center;color:#1c1917;">
        <h2 style="font-size:32px;margin:0 0 32px;font-family:Georgia,serif;">Il menù</h2>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:20px;">
          <div><img src="https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=400" style="width:100%;height:160px;object-fit:cover;border-radius:12px;" alt=""><h3>Antipasti</h3></div>
          <div><img src="https://images.unsplash.com/photo-1551183053-bf91a1d81141?w=400" style="width:100%;height:160px;object-fit:cover;border-radius:12px;" alt=""><h3>Primi</h3></div>
          <div><img src="https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=400" style="width:100%;height:160px;object-fit:cover;border-radius:12px;" alt=""><h3>Dolci</h3></div>
        </div>
      </section>
      <footer style="background:#1c1917;color:#a8a29e;padding:28px;text-align:center;font-size:14px;">Via Roma 1 · Tel 06 1234567</footer>`),
  },
  {
    id: "portfolio",
    name: "Portfolio",
    desc: "Minimale per creativi e freelance",
    accent: "#111827",
    html: doc(`
      <section style="padding:120px 32px;text-align:center;max-width:760px;margin:0 auto;color:#111827;">
        <div style="width:110px;height:110px;border-radius:999px;background:#111827;margin:0 auto 24px;"></div>
        <h1 style="font-size:52px;margin:0 0 12px;">Ciao, sono Marco</h1>
        <p style="font-size:20px;color:#6b7280;margin:0 0 28px;">Designer e sviluppatore. Creo esperienze digitali semplici e belle.</p>
        <a href="#" style="border:2px solid #111827;color:#111827;font-weight:700;padding:12px 28px;border-radius:8px;text-decoration:none;">Guarda i progetti</a>
      </section>
      <section style="padding:40px 32px 90px;max-width:1000px;margin:0 auto;">
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(260px,1fr));gap:20px;">
          <img src="https://picsum.photos/500/350?random=11" style="width:100%;height:220px;object-fit:cover;border-radius:16px;" alt="">
          <img src="https://picsum.photos/500/350?random=12" style="width:100%;height:220px;object-fit:cover;border-radius:16px;" alt="">
          <img src="https://picsum.photos/500/350?random=13" style="width:100%;height:220px;object-fit:cover;border-radius:16px;" alt="">
        </div>
      </section>`),
  },
  {
    id: "saas",
    name: "App / SaaS",
    desc: "Landing moderna per prodotti digitali",
    accent: "#7c3aed",
    html: doc(`
      <header style="padding:18px 32px;display:flex;justify-content:space-between;align-items:center;color:#111827;">
        <strong style="font-size:20px;">Flowly</strong>
        <a href="#" style="background:#7c3aed;color:#fff;padding:10px 20px;border-radius:8px;text-decoration:none;font-size:14px;">Prova gratis</a>
      </header>
      <section style="padding:90px 32px;text-align:center;background:linear-gradient(180deg,#faf5ff,#fff);color:#111827;">
        <h1 style="font-size:52px;margin:0 0 16px;max-width:740px;margin-left:auto;margin-right:auto;">Gestisci il tuo lavoro, senza sforzo</h1>
        <p style="font-size:20px;color:#6b7280;max-width:560px;margin:0 auto 30px;">L'app tutto-in-uno per team che vogliono andare veloci.</p>
        <a href="#" style="background:#7c3aed;color:#fff;font-weight:700;padding:15px 34px;border-radius:10px;text-decoration:none;">Inizia ora</a>
        <div style="margin-top:50px;"><img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=900" style="width:100%;max-width:820px;border-radius:16px;box-shadow:0 20px 50px rgba(0,0,0,.15);" alt=""></div>
      </section>
      <section style="padding:72px 32px;max-width:1000px;margin:0 auto;text-align:center;color:#111827;">
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:24px;">
          <div><h3>⚡ Veloce</h3><p style="color:#6b7280;">Tutto in tempo reale.</p></div>
          <div><h3>🔒 Sicuro</h3><p style="color:#6b7280;">Dati protetti.</p></div>
          <div><h3>🤝 Collaborativo</h3><p style="color:#6b7280;">Per tutto il team.</p></div>
        </div>
      </section>`),
  },
];
